import Image from "next/image";
import { GAME_PLATFORM_LINKS } from "../_constants/about-constants";
import { GamePlatformLink } from "./GamePlatformLink";
import { Trans } from "next-i18next";
import { useTrans } from "@/utils/useTrans";
import { useCompatibleGamesSummary } from "@/api/game-api";

export default function GamePlatformGrid() {
  return (
    <>
      <Desktop />
      <Mobile />
    </>
  );
}

function Desktop() {
  const { t } = useTrans(["about"]);
  const { data } = useCompatibleGamesSummary();
  const nativeTotal = data?.native.total ?? 0;

  return (
    <div className="relative hidden h-[560px] w-full overflow-hidden rounded-2xl smd:flex">
      <div className="inline-flex h-72 flex-wrap content-start items-start justify-start gap-3 self-stretch">
        <Image
          className="absolute inset-0 h-full w-full rounded-2xl object-cover"
          src="/images/about/games.png"
          alt="Game platforms background"
          fill
        />
      </div>
      <div className="absolute left-[80px] top-[88px] inline-flex flex-col items-center justify-center gap-8 text-white">
        <p className="justify-start text-center text-4xl">
          <Trans
            t={t}
            i18nKey="{{total}}+ Natively <br/> Compatible Games"
            defaultValue={`${nativeTotal}+ Natively Compatible Games`}
            components={{ br: <br /> }}
            values={{ total: nativeTotal }}
          />
        </p>
        <div className="grid grid-cols-3 gap-3">
          {GAME_PLATFORM_LINKS.map((platform, index) => (
            <GamePlatformLink
              key={index}
              href={platform.href}
              icon={platform.icon}
              bgColor={platform.bgColor}
              title={platform.title}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

function Mobile() {
  const { t } = useTrans(["about"]);
  const { data } = useCompatibleGamesSummary();
  const nativeTotal = data?.native.total ?? 0;

  return (
    <div className="flex w-full flex-col overflow-hidden smd:hidden smd:rounded-2xl">
      <p className="mb-5 justify-start text-center text-2xl smd:text-3xl">
        <Trans
          t={t}
          i18nKey="{{total}}+ Natively <br/> Compatible Games"
          defaultValue={`${nativeTotal}+ Natively Compatible Games`}
          components={{ br: <br /> }}
          values={{ total: nativeTotal }}
        />
      </p>
      <div className="relative mb-4 aspect-square w-full flex-wrap content-start items-start justify-start gap-3 overflow-hidden rounded-xl">
        <Image
          className="absolute object-cover"
          src="/images/about/m-games.png"
          alt="Game platforms background"
          fill
        />
      </div>
      <div className="inline-flex flex-col items-center justify-center gap-4">
        <div className="grid w-full grid-cols-2 gap-3">
          {GAME_PLATFORM_LINKS.map((platform, index) => (
            <GamePlatformLink
              key={index}
              href={platform.href}
              icon={platform.icon}
              bgColor={platform.bgColor}
              title={platform.title}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
